module.exports = __webpack_public_path__ + "img/hexagon.824c4bcf.svg";